import {
    STOREFRONT_VALUES_KEYS,
    STOREFRONT_VALUES_NAMESPACES,
} from "@/constants/storefront_values";
import { StorefrontValuesModule } from "@modules/storefront_values/StorefrontValuesModule";
import { inject } from "tsyringe";

import { GrowaveStorefrontValuesAccountUISchema } from "../schemas/GrowaveStorefrontValuesAccountUISchema";
import { GrowaveStorefrontValuesCheckoutUISchema } from "../schemas/GrowaveStorefrontValuesCheckoutUISchema";
import { GrowaveStorefrontValuesWatermarkSchema } from "../schemas/GrowaveStorefrontValuesWatermarkSchema";

class GrowaveStorefrontValuesService {
    constructor(
        @inject(StorefrontValuesModule)
        private readonly storefrontValuesModule: StorefrontValuesModule
    ) {}

    public selectWatermarkSettings() {
        return this.storefrontValuesModule.exports.storefrontValuesManager.selectValue(
            {
                namespace: STOREFRONT_VALUES_NAMESPACES.GROWAVE_CRITICAL,
                key: STOREFRONT_VALUES_KEYS.WATERMARK,
                schema: GrowaveStorefrontValuesWatermarkSchema,
            }
        );
    }

    public selectCheckoutUISettings() {
        return this.storefrontValuesModule.exports.storefrontValuesManager.selectValue(
            {
                namespace: STOREFRONT_VALUES_NAMESPACES.GROWAVE_CRITICAL,
                key: STOREFRONT_VALUES_KEYS.CHECKOUT_UI,
                schema: GrowaveStorefrontValuesCheckoutUISchema,
            }
        );
    }

    public selectAccountUISettings() {
        return this.storefrontValuesModule.exports.storefrontValuesManager.selectValue(
            {
                namespace: STOREFRONT_VALUES_NAMESPACES.GROWAVE_CRITICAL,
                key: STOREFRONT_VALUES_KEYS.ACCOUNT_UI,
                schema: GrowaveStorefrontValuesAccountUISchema,
            }
        );
    }
}

export default GrowaveStorefrontValuesService;
